import { render, staticRenderFns } from "./ConfirmationSendTransactionDetails.vue?vue&type=template&id=dcc39062&"
import script from "./ConfirmationSendTransactionDetails.vue?vue&type=script&lang=js&"
export * from "./ConfirmationSendTransactionDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports